// extracted by mini-css-extract-plugin
module.exports = {"text":"plainText_text__rMuG6","description":"plainText_description__1IFSd"};